<template>
  <div class="home">
    <card1 :img="showData.banner"
           :txt="showData.Txt">
    </card1>
    <div class="home-footer">
      <span class="home-footer-item"
            v-for="(item, index) in showData.ITEMS"
            :key="index">
        <img @click.prevent
             :src="item.icon">
        <div class="home-footer-item-txt"
             v-html="item.txt"></div>
      </span>
    </div>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例
import card1 from 'components/card1.vue'
export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      CN: {
        banner: require('images/home/banner.png'),
        Txt: '优托邦(UTOPA)是一个拥有全新商业理念的新经济服务平台，以人为核心，探索人与人、人与自然、人与科技的关系，用科技智能手法将实体、线上、虚拟相联结，创建多维度欢乐社交空间。<br>优托邦UTOPA创新设计实体和线上主题场景，强调丰富体验，满足全方位社交需求。旗下拥有时尚、餐饮、儿童、运动、艺术生活、创新办公等覆盖全方位生活需求的主力品牌，并通过全球品牌客户关系合作网络，开发管理及运营近 250万㎡的商业项目。',
        ITEMS: [
          { icon: require('images/home/owner.png'), txt: '为业主创造价值<br>提供资源' },
          { icon: require('images/home/merchant.png'), txt: '为商户创造收益<br>提供平台' },
          { icon: require('images/home/member.png'), txt: '为会员创造体验<br>提供服务' }
        ]
      },
      ZH: {
        banner: require('images/home/banner_1.png'),
        Txt: '優托邦(UTOPA)是一個擁有全新商業理念的新經濟服務平臺，以人為核心，探索人與人、人與自然、人與科技的關係，用科技智慧手法將實體、線上、虛擬相聯結，創建多維度歡樂社交空間。<br>優托邦UTOPA創新設計實體和線上主題場景，強調豐富體驗，滿足全方位社交需求。旗下擁有時尚、餐飲、兒童、運動、藝術生活、創新辦公等覆蓋全方位生活需求的主力品牌，並通過全球品牌客戶關係合作網路，開發管理及運營近 250萬㎡的商業專案。',
        ITEMS: [
          { icon: require('images/home/owner.png'), txt: '為業主創造價值<br>提供資源' },
          { icon: require('images/home/merchant.png'), txt: '為商戶創造收益<br>提供平台' },
          { icon: require('images/home/member.png'), txt: '為會員創造體驗<br>提供服務' }
        ]
      }
    }
  },
  components: { card1 },
  watch: {},
  computed: {},
  created () {
  },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.home {
  padding: px2rem(44) 0;
  &-footer {
    text-align: center;
    &-item {
      display: inline-block;
      width: 30%;
      img {
        width: px2rem(50);
      }
      &-txt {
        font-size: px2rem(12);
        color: #3c3c3c;
        letter-spacing: 0;
        line-height: px2rem(20);
        font-weight: bold;
      }
    }
  }
}
</style>
